import PropTypes from "prop-types";


function Conditional({ check, children }) {
    if (check) {
        return children;
    }
    return null;
}

Conditional.propTypes = {
    check: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

export default Conditional;
